import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { useAppSelector, selectTenantId } from 'slices/commonSelectors';

export const keys = {
  customTemplates: 'customTemplates',
};

export const useFetchCustomTemplates = () => {
  const tenantId = useAppSelector(selectTenantId);

  return useQuery({
    queryKey: [keys.customTemplates, tenantId],
    queryFn: async () => {
      const response = await axios(
        `${config.apiGateway.customTeamTemplates}/${tenantId}`,
        {
          method: 'GET',
        }
      );
      return response?.data;
    },
    enabled: !!tenantId,
  });
};
